<template>
  <v-row>
    <v-col cols="auto">
      <v-select
        prepend-icon="mdi-sort"
        :items="items"
        class="sort"
        v-model="field"
        label="Order By"
        @change="changed"
        hide-details
        dense
        :menu-props="{ bottom: true, offsetY: true }"
        outlined
      >
      </v-select>
    </v-col>
    <v-col cols="auto">
      <Tooltip content="Sort Order" bottom>
        <v-btn-toggle
          v-model="order"
          color="success"
          dense
          group
          mandatory
          @change="changed"
        >
          <v-btn :value="1">
            <v-icon>mdi-sort-ascending</v-icon>
          </v-btn>

          <v-btn :value="-1">
            <v-icon>mdi-sort-descending</v-icon>
          </v-btn>
        </v-btn-toggle>
      </Tooltip>
    </v-col>
    <!-- <v-col cols="auto">
      <v-row>
        <v-col cols="auto" class="mx-0 px-0 mt-2"
          >
<v-icon>mdi-sort-ascending</v-icon>
</v-col
        >
        <v-col cols="auto">
          <v-switch
            class="mt-1"
            v-model="order"
            true-value="-1"
            false-value="1"
            @change="changed"
          >
</v-switch
        >
</v-col>
        <v-col cols="auto" class="mx-0 px-0 mt-2"
          >
<v-icon class="rotated">mdi-sort-descending</v-icon>
</v-col
        >
      </v-row>
    </v-col> -->
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  components: { Tooltip },
  name: "SortComp",

  data() {
    return {
      // value: "",
      // order: 1,
    };
  },
  props: {
    value: VueTypes.any.def({}),
    items: VueTypes.any.def([]),
  },
  methods: {
    changed() {
      const val: any = {};
      val[this.field] = this.order;
      this.$emit("changed", { key: "sort", val });
      this.$emit("input", { [this.field]: this.order });
    },
    titled(str: string) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  computed: {
    sort: {
      get(): unknown {
        return this.value;
      },
      set(val: unknown) {
        this.$emit("input", val);
      },
    },
    field: {
      get(): string {
        const field = `${Object.keys(this.sort)[0]}`;
        return field;
      },
      set(field: string) {
        this.$emit("input", { [field]: this.order });
      },
    },
    order: {
      get(): number {
        const val = +Object.values(this.sort)[0];
        return val;
      },
      set(val: number) {
        console.log(val);
        this.$emit("input", { [this.field]: val });
      },
    },
  },
});
</script>

<style>
.sort {
  width: 150px;
}
.rotated {
  transform: rotate(180deg);
}
</style>
